<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="utility()"
  [imageUrl]="(imageUrl$() | async) || defaultImageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [monitoringCategory]="MonitoringCategory.UTILITY"
      [monitoringItems]="monitoringItems"
      [monitoringTitle]="monitoringTitle"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="utility()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-custom-part-numbers [floorplanItem]="utility()"></app-floorplan-custom-part-numbers>
    </div>
  }
</app-floorplan-item-details>
